module.exports = __webpack_public_path__ + "static/img/system-1.6f9bd28b.png";